import { RentalPortalListingProfileWidgetAddress } from '../../../RentalPortalListingProfileWidgetAddress'
import { RentalPortalListingProfileWidgetAttention } from '../../../RentalPortalListingProfileWidgetAttention'
import { RentalPortalListingProfileWidgetCreated } from '../../../RentalPortalListingProfileWidgetCreated'
import { RentalPortalListingProfileWidgetPerformance } from '../../../RentalPortalListingProfileWidgetPerformance'
import { RentalPortalListingProfileWidgetPortals } from '../../../RentalPortalListingProfileWidgetPortals'
import { RentalPortalListingProfileWidgetPublishing } from '../../../RentalPortalListingProfileWidgetPublishing'
import { LISTING_PROFILE_WIDGET_KEY } from '../../RentalPortalListingProfileWidgetList.constants'

export function useListingProfileWidgets() {
  const widgets = {
    [LISTING_PROFILE_WIDGET_KEY.address]: (
      <RentalPortalListingProfileWidgetAddress />
    ),
    [LISTING_PROFILE_WIDGET_KEY.attention]: (
      <RentalPortalListingProfileWidgetAttention />
    ),
    [LISTING_PROFILE_WIDGET_KEY.createdUpdated]: (
      <RentalPortalListingProfileWidgetCreated />
    ),
    [LISTING_PROFILE_WIDGET_KEY.performance]: (
      <RentalPortalListingProfileWidgetPerformance />
    ),
    [LISTING_PROFILE_WIDGET_KEY.portalLinks]: (
      <RentalPortalListingProfileWidgetPortals />
    ),
    [LISTING_PROFILE_WIDGET_KEY.publishing]: (
      <RentalPortalListingProfileWidgetPublishing />
    ),
  }

  return { widgets }
}
